import { bus } from 'shared/core';

class Events {
  _store;

  init(store) {
    this._store = store;
    bus.on('order', this.onOrder);
  }

  onOrder = order => {
    this._store.dispatch('checker$orders/addValueAction', order);
  };
}

export default new Events();
